<script setup>
    import {
        useRouter
    } from 'vue-router';
    import {
        Fold,
        Expand,
        BellFilled,
        ArrowDown,
        ArrowRight
    } from '@element-plus/icons-vue';
    import {
        ElMessage,
        ClickOutside as vClickOutside
    } from 'element-plus';
    import {
        computed,
        onMounted,
        onBeforeUnmount,
        ref,
        unref,
        inject,
        watch,
        reactive
    } from 'vue';
    import {
        useStore
    } from 'vuex';
    import {
        getFontMsgApi,
        getReadHistory
    } from '@/apis/common';
    import {
        Vue3Marquee
    } from 'vue3-marquee';
    import Breadcrumb from '@/layout/Breadcrumb.vue';
    import {
        require,
        formatDateTime
    } from '@/utils/index';
    import language from '@/components/center/language.vue';
    import profile_avatar from '@/assets/images/center/profile_avatar.png';
    import profile_hat from '@/assets/images/festival/hat.png';
    import {
        readContent
    } from '@/apis/common'
    import open_img from '@/assets/images/center/open.png'
    import close_img from '@/assets/images/center/close.png'
    import {
        transform
    } from 'lodash';
    const langrage = inject('langrage');
    const router = useRouter();
    const store = useStore();
    const sidebarOpen = computed(() => store.state.sidebarOpen);
    const userInfo = computed(() => store.state.user.userInfo);
    const currentUser = computed(() => userInfo.value?.user || {});
    const userMessage = computed(() =>
        store.state.user.userMessage
    )
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)')
    const isMobile = ref(mobileMediaQuery.matches)
    const visible = ref(false)
    const unreadCount = computed(() =>
        (userMessage.value || []).filter(item => item.isRead == 2).length
    )
    const badge = computed(() => unreadCount.value || '')
    const readHistoryList = ref([])
    const isHistoryMode = ref(false)
    const historyLoading = ref(false)
    const displayedMessages = computed(() =>
        isHistoryMode.value ? readHistoryList.value : (userMessage.value || [])
    )

    watch([unreadCount, isMobile], ([count, mobile]) => {
        visible.value = mobile && count > 0
    }, { immediate: true })

    const handleMobileChange = (event) => {
        isMobile.value = event.matches
    }

    const openStatus = ref(false)
    const changeOpenStatus = () => {
        openStatus.value = !openStatus.value
        if (unreadCount.value === 0) {
            visible.value = false;
        }
    }
    const fontMsg = ref({});
    const fontFamily = ref('');
    const lang = localStorage.getItem('langrage');
    // 修改打开消息面板的方法
    const openMessage = () => {
        if (isMobile.value) {
            isHistoryMode.value = false;
            visible.value = true;
        }
    }
    // 关闭消息弹窗
    const closeMessage = () => {
        isHistoryMode.value = false;
        visible.value = false;
    }

    // 获取历史消息
    const toggleMessageHistory = async () => {
        if (isHistoryMode.value) {
            isHistoryMode.value = false;
            return;
        }

        const userId = currentUser.value.userId;
        if (!userId || historyLoading.value) return;

        historyLoading.value = true;
        try {
            const { data } = await getReadHistory({ userId });
            readHistoryList.value = Array.isArray(data) ? data : [];
            isHistoryMode.value = true;
        } catch (error) {
            console.error(error);
        } finally {
            historyLoading.value = false;
        }
    }
    // console.log('userInfo:', subUser);
    const handleCommand = (command) => {
        ElMessage(`click on item ${command}`);
    };

    const changeSidebar = () => {
        store.commit('TOGGLE_SIDEBAR');
    };
    const loginOut = async () => {
        await store.dispatch('user/logout');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
        window.location.reload();
    }
    const jumpPage = (path) => {
        router.push(path);
        // setTimeout(() => {
        //     location.reload();
        // }, 100);
    };

    // 获取公告信息
    const getFontMsg = async () => {
        try {
            const {
                data,
                code,
                msg
            } = await getFontMsgApi();
            // console.log(data, '44===');
            fontMsg.value = data;
            fontFamily.value = `'Be Vietnam Pro', 'source-han-sans', sans-serif`;
        } catch (error) {
            console.error(error);
        }
    };

    const changeType = async (item) => {
        // console.log('先进入');


        let Timer = null

        if (item.isRead == 2) {
            //先前端改变状态,让使用变得丝滑
            store.commit('user/CHANGE_MESSAGE_TYPE', item.id)
            //然后找到传来的id,调接口把未读变为已读
            await readContent({
                userId: currentUser.value.userId,
                id: item.id
            })
            //要做个防抖,我们只更新最后一次的消息数据,防止点了未读马上调接口回头影响其他数据
            if (Timer) {
                clearTimeout(Timer)
            }
            Timer = setTimeout(async () => {
                //获取铃铛信息
                await store.dispatch('user/getRemindContent');
            }, 500)
        } else if (!item) {
            //如果传的是空就是一键已读,调接口
            // console.log(1, '如果不存在item');
            await readContent({
                userId: currentUser.value.userId,
                id: null
            })
            // console.log(2);
            //获取铃铛信息
            await store.dispatch('user/getRemindContent');
            // console.log(3);

        }

    }
    const goMessage = () => {
        router.push('/account/profile');
    };
    const checkIn = async () => {
        //localStorage.clear();
        await store.dispatch('user/logout');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
        window.location.reload();
    };

    onMounted(() => {
        mobileMediaQuery.addEventListener('change', handleMobileChange)
        getFontMsg();
        const dropDownTrigger = document.getElementById('popover')
        // console.log(dropDownTrigger);

        dropDownTrigger.addEventListener('click', () => {
            // console.log(121212);
            // visible.value = !visible.value
            // console.log('userMessage', userMessage);
            // console.log('userMessage', store.state.user.userMessage);
        });
        // dropDownTrigger.addEventListener('mouseleave', () => {
        //     if (!store.state.user.userMessage.length) {
        //         visible.value = false
        //     }
        // });

    });

    onBeforeUnmount(() => {
        mobileMediaQuery.removeEventListener('change', handleMobileChange)
    })

    const menuList = reactive([{
            route: '/dashboard',
            title: langrage['center'],
            className: 'route_title',
            id: 1,
            icon: require('@/assets/images/center/menu_icon/menu_dashboard.png'),
        },
        {
            route: '',
            title: langrage['tabTitle2'],
            className: 'title',
            id: 6,
            icon: require('@/assets/images/center/pre.png')
        },
        {
            route: '/senior/price',
            title: langrage['price'],
            className: 'route_title',
            id: 7,
            icon: require('@/assets/images/center/menu_icon/menu_price.png')
        },
        {
            route: '/senior/proxyAccess',
            title: langrage['getIP'],
            className: 'route_title',
            id: 8,
            icon: require('@/assets/images/center/menu_icon/menu_proxy.png')
        },
        {
            route: '/senior/plans',
            title: langrage['panel6text6'],
            className: 'route_title',
            id: 9,
            icon: require('@/assets/images/center/menu_icon/menu_plans.png')
        },
        {
            route: '',
            title: langrage['tabTitle'],
            className: 'title',
            id: 2,
            icon: require('@/assets/images/center/home_icon.png')
        },
        {
            route: '/product/price',
            title: langrage['price'],
            className: 'route_title',
            id: 3,
            icon: require('@/assets/images/center/menu_icon/menu_price.png')
        },
        {
            route: '/product/proxyAccess',
            title: langrage['getIP'],
            className: 'route_title',
            id: 4,
            icon: require('@/assets/images/center/menu_icon/menu_proxy.png')
        },
        {
            route: '/product/plans',
            title: langrage['panel6text6'],
            className: 'route_title',
            id: 5,
            icon: require('@/assets/images/center/menu_icon/menu_plans.png')
        },
        {
            route: '',
            title: langrage['tabTitle3'],
            className: 'title',
            id: 16,
            icon: require('@/assets/images/center/home_mobile.png')
        },
        {
            route: '/mobility/price',
            title: langrage['price'],
            className: 'route_title',
            id: 17,
            icon: require('@/assets/images/center/menu_icon/menu_price.png')
        },
        {
            route: '/mobility/proxyAccess',
            title: langrage['getIP'],
            className: 'route_title',
            id: 18,
            icon: require('@/assets/images/center/menu_icon/menu_proxy.png')
        },
        {
            route: '/mobility/plans',
            title: langrage['panel6text6'],
            className: 'route_title',
            id: 19,
            icon: require('@/assets/images/center/menu_icon/menu_plans.png')
        },
        {
            route: '',
            title: langrage['tabTitle5_3'] + langrage['proxy'],
            className: 'title',
            id: 20,
            icon: require('@/assets/images/center/home-isp.png')
        },
        {
            route: '/ISP/price',
            title: langrage['price'],
            className: 'route_title',
            id: 24,
            icon: require('@/assets/images/center/menu_icon/menu_price.png')
        },
        {
            route: '/ISP/plans',
            title: 'IP' + langrage['uipnt4'],
            className: 'route_title',
            id: 25,
            icon: require('@/assets/images/center/menu_icon/menu_plans.png')
        },
        {
            route: '',
            title: langrage['tabTitle5_1'] + langrage['proxy'],
            className: 'title',
            id: 20,
            icon: require('@/assets/images/center/home-ipv4.png')
        },
        {
            route: '/IPv4/price',
            title: langrage['price'],
            className: 'route_title',
            id: 26,
            icon: require('@/assets/images/center/menu_icon/menu_price.png')
        },
        {
            route: '/IPv4/plans',
            title: 'IP' + langrage['uipnt4'],
            className: 'route_title',
            id: 27,
            icon: require('@/assets/images/center/menu_icon/menu_plans.png')
        },
        {
            route: '',
            title: langrage['tabTitle5_2'] + langrage['proxy'],
            className: 'title',
            id: 20,
            icon: require('@/assets/images/center/home-ipv6.png')
        },
        {
            route: '/IPv6/price',
            title: langrage['price'],
            className: 'route_title',
            id: 28,
            icon: require('@/assets/images/center/menu_icon/menu_price.png')
        },
        {
            route: '/IPv6/plans',
            title: 'IP' + langrage['uipnt4'],
            className: 'route_title',
            id: 29,
            icon: require('@/assets/images/center/menu_icon/menu_plans.png')
        },
        // 无限
        {
            route: '',
            title: langrage['tabTitle5_4'] + langrage['proxy'],
            className: 'title',
            id: 20,
            icon: require('@/assets/images/center/home_infinte.png')
        },
        {
            route: '/Infinite/price',
            title: langrage['price'],
            className: 'route_title',
            id: 28,
            icon: require('@/assets/images/center/menu_icon/menu_price.png')
        },
        {
            route: '/Infinite/plans',
            title: 'IP' + langrage['uipnt4'],
            className: 'route_title',
            id: 29,
            icon: require('@/assets/images/center/menu_icon/menu_plans.png')
        },
        {
            route: '',
            title: langrage['account_manage'],
            className: 'title',
            id: 10,
            icon: require('@/assets/images/center/menu_icon/menu_proxy_accounts.png')
        },
        {
            route: '/account/profile',
            title: langrage['profile1'],
            className: 'route_title',
            id: 11,
            icon: require('@/assets/images/center/menu_icon/profile.png')
        },
        {
            route: '/account/billings',
            title: langrage['billing1'],
            className: 'route_title',
            id: 12,
            icon: require('@/assets/images/center/menu_icon/menu_billings.png')
        },
        {
            route: '/rocketWallet/index',
            title: langrage['router_RocketWallet'],
            className: 'route_title',
            id: 13,
            icon: require('@/assets/images/center/menu_icon/menu_rocket_wallet.png')
        },
        {
            route: '/referralProgram/index',
            title: langrage['router_Affiliate'],
            className: 'route_title',
            id: 14,
            icon: require('@/assets/images/center/menu_icon/menu_referral.png')
        },
        {
            route: '/partner/partner',
            title: langrage['partner'],
            className: 'route_title',
            id: 15,
            icon: require('@/assets/images/center/menu_icon/partner.png')
        },
        // {
        //     route: 'help',
        //     title: langrage['dashboard12'],
        //     className: 'route_title',
        //     id: 16,
        //     icon: require('@/assets/images/center/menu_icon/menu_help.png')
        // },
    ])
    const changeMenu = (item) => {
        menuList.forEach((i) => {
            if (!i.title || i.className == 'title') {} else {
                i.className = 'route_title'
                if (i.id == item.id) {
                    i.className = 'bc_blue'
                    openStatus.value = false
                    if (item.id == 16) {
                        window.open('https://help.iprocket.io/');
                    } else {
                        router.push(item.route)
                    }
                }
            }

        })
    }
</script>

<template>
    <div class="navbar">
        <!-- 滚动模块 -->
        <!-- <div class="tips" style="font-size: 1.4rem; width: 92rem">
            <Vue3Marquee :duration="lang == 'chinese' ? fontMsg.flowSecond : fontMsg.flowSecond2" :pauseOnHover="true">
                <span v-if="lang == 'chinese'" :style="{ fontFamily: fontFamily, color: fontMsg.colors }">{{
                    fontMsg.valueInfo
                    }}</span>
                <span v-if="lang == 'english'" :style="{ fontFamily: fontFamily, color: fontMsg.colors }">{{
                    fontMsg.valueInfo2
                    }}</span>
            </Vue3Marquee>
        </div> -->

        <div class="right">

            <!-- 个人中心模块 -->
            <div class="user-info flex-center" @click="jumpPage('/account/profile')">

                <el-dropdown class="flex-center">
                    <div class="avatar-group">
                        <img class="avatar" :src="profile_avatar" alt="" />
                        <!-- <img class="avatar-hat" :src="profile_hat" alt="" /> -->
                    </div>
                    <!-- <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item command="zh" @click="goMessage">{{ langrage['profile1']
                                }}</el-dropdown-item>
                            <el-dropdown-item command="es" @click="checkIn">{{ langrage['navbar4'] }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </template> -->
                </el-dropdown>
                <span style="margin-left: 1.5rem;font-size: 1.7rem;">{{ currentUser.userName || '' }}</span>
            </div>

            <!-- 钱包模块 -->
            <!-- <div class="btn flex-center" @click="jumpPage('/rocketWallet/index')" style="margin-right: 2rem;">
                <img class="icon" :src="require('@/assets/images/center/Wallet_balance.png')" alt="" />
                <span>{{ langrage['centerNav_t1'] }}${{ currentUser.walletBalance ?? 0 }}</span>
                <el-icon>
                    <ArrowRight />
                </el-icon>
            </div> -->
            <div style="display: flex;justify-content: flex-end;">
                <!-- 提醒模块 -->
                <el-popover :visible="visible" :popper-style="{ left: '50%', transform: 'translateX(-50%)' }"
                    trigger="click" :width="360">
                    <div class="popover_content" v-loading="historyLoading">
                        <div class="mobile-message-header">
                            <p class="popover_title">{{ langrage['dashboard31'] }}</p>
                            <div class="history-title" @click="toggleMessageHistory">
                                {{ isHistoryMode ? langrage['dashboard54'] : langrage['dashboard53'] }}
                            </div>
                        </div>
                        <div class="popover_tip_content">
                            <div v-if="displayedMessages.length" class="popover_text_content"
                                v-for="(item, index) in displayedMessages" :key="item.id || index">
                                <div class="num_content">
                                    <p class="num">{{ index + 1 }}.</p>
                                    <p v-if="lang == 'chinese'" class="popover_text">
                                        {{ item.pushInfo }}
                                    </p>
                                    <p v-else class="popover_text">
                                        {{ item.pushInfoEn }}
                                    </p>
                                </div>
                                <div class="bottom_content">
                                    <div class="popover_time">
                                        {{ formatDateTime(item.updateTime || item.createTime) }}
                                    </div>
                                    <div v-if="lang === 'chinese'" class="popover_type"
                                        @click="!isHistoryMode && changeType(item)"
                                        :class="{ blue: item.isRead == 2, disabled: isHistoryMode }">
                                        <!-- 35已读36未读 -->
                                        {{ item.isRead == 2 ? langrage['dashboard36'] :
                                            langrage['dashboard35']
                                        }}
                                    </div>
                                    <div v-else class="popover_type small-font"
                                        @click="!isHistoryMode && changeType(item)"
                                        :class="{ blue: item.isRead == 2, disabled: isHistoryMode }">
                                        <!-- 35已读36未读 -->
                                        {{ item.isRead == 2 ? langrage['dashboard36'] :
                                        langrage['dashboard35']
                                        }}
                                    </div>
                                </div>
                                
                            </div>
                            <div v-else style="text-align: center;margin-top: 23vh;">
                                {{ isHistoryMode ? langrage['dashboard42'] : langrage['dashboard38'] }}
                            </div>
                        </div>
                        <div v-if="!isHistoryMode && userMessage.length" class="popover_botton_content">
                            <el-button size="small" text @click="closeMessage">{{ langrage['dashboard37']
                            }}</el-button>
                            <el-button size="small" @click="changeType('')" color="#2b6bff" type="primary" class="">
                                {{ langrage['dashboard32'] }}
                            </el-button>
                        </div>
                    </div>
                    <template #reference>
                        <div id="popover" @click="openMessage">
                            <el-badge class="badge" :value="badge" :max="99" :offset="[3, -1]">
                                <img v-if="!badge" :src="require('@/assets/images/center/notice.png')" ref="buttonRef" />
                                <img v-else :src="require('@/assets/images/center/notice.png')" ref="buttonRef"/>
                                <!-- <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M17.5 1.875H2.5C1.4375 1.875 0.625 2.6875 0.625 3.75V13.125C0.625 14.1875 1.4375 15 2.5 15H3.75V17.5C3.75 17.75 3.875 17.9375 4.0625 18.0625C4.1875 18.125 4.25 18.125 4.375 18.125C4.5 18.125 4.625 18.0625 4.75 18L8.9375 15H17.5C18.5625 15 19.375 14.1875 19.375 13.125V3.75C19.375 2.6875 18.5625 1.875 17.5 1.875ZM11.25 11.25H5.625C5.25 11.25 5 11 5 10.625C5 10.25 5.25 10 5.625 10H11.25C11.625 10 11.875 10.25 11.875 10.625C11.875 11 11.625 11.25 11.25 11.25ZM14.375 6.875H5.625C5.25 6.875 5 6.625 5 6.25C5 5.875 5.25 5.625 5.625 5.625H14.375C14.75 5.625 15 5.875 15 6.25C15 6.625 14.75 6.875 14.375 6.875Z"
                                        fill="#19304A"></path>
                                </svg> -->
                            </el-badge>
                        </div>
                    </template>
                </el-popover>
                <div class="select flex-center">
                    <language />
                </div>
                <div>
                    <img class="menu-icon" :src="open_img" @click="changeOpenStatus">
                </div>
            </div>
        </div>
        <div class="menu-overlay" v-show="openStatus" @click="changeOpenStatus"></div>
        <div class="menu" v-show="openStatus">
            <img class="menu-icon" v-if="openStatus" :src="close_img" @click="changeOpenStatus">
            <div v-for="item in menuList" :class="item.className" style="display: flex;align-items: center;"
                @click="changeMenu(item)">
                <img :src="item.icon" :style="{ width: item.className == 'title' ? '3rem' : '' }"></img>
                <div style="margin-left: 2rem;">{{ item.title }}</div>
            </div>
            <div class="login_out_content">
                <div class="login_out" @click="loginOut">
                    <div class="text">
                        {{ langrage['centerNav_t6'] }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .navbar {
        display: none;
    }
    // 响应式设计
        @media (max-width: 768px) {
           @keyframes s1Animation {
               0% {
           
                   height: 0vh;
               }
           
               100% {
                   height: 98vh;
               }
           }
           
           .menu-icon {
               width: 4rem;
           }
           
           .menu-overlay {
               position: fixed;
               top: 0;
               left: 0;
               width: 100%;
               height: 100%;
               background-color: rgba(0, 0, 0, 0.5);
               z-index: 9998;
           }
           
           .menu {
               padding: 3rem 3rem 20rem 3rem;
               width: 55vw;
               position: absolute;
               top: 0;
               right: 0;
               z-index: 9999;
               background-color: #fff;
               animation-name: s1Animation;
               animation-duration: 0.1s;
               animation-timing-function: linear;
               animation-fill-mode: forwards;
               overflow-y: auto;
           
               .login_out_content {
                   cursor: pointer;
                   margin-top: 2rem;
                   margin-bottom: 0rem;
                   width: 100%;
                   height: 6rem;
                   background: #fff;
                   display: flex;
                   justify-content: center;
                   align-items: center;
           
                   .login_out {
                       border-radius: 0.5rem 0rem 0rem 0.5rem;
                       border: 1px solid #2B6BFF;
                       width: 100%;
                       height: 5rem;
                       display: flex;
                       align-items: center;
                       justify-content: center;
           
                       .text {
           
                           font-weight: 500;
                           font-size: 1.8rem;
                           color: #333 !important;
                       }
                   }
           
               }
           
               .title {
                   margin: 2rem 0;
                   margin-left: 3rem;
                   font-size: 2.1rem;
                   color: #555555;
                   font-weight: 500;
               }
           
               .route_title {
                   padding: 1rem 7rem;
                   margin: 0rem 0rem;
                   // margin-left: 7rem;
                   font-size: 1.9rem;
               }
           
               .bc_blue {
                   padding: 1.5rem 7rem;
                   margin: 0rem 0rem;
                   // margin-left: 7rem;
                   font-size: 2rem;
                   background-color: #cae5ff !important;
               }
           }
           
           .blue {
               color: #2b6bff !important;
           }
           
           .popover_content {
               min-height: 50vh;

               .mobile-message-header {
                   display: flex;
                   align-items: center;
                   justify-content: space-between;
                   gap: 1rem;

                   .history-title {
                       flex-shrink: 0;
                       color: #2a5eff;
                       font-size: 2.2rem;
                       cursor: pointer;
                   }
               }

               .popover_title {
                   margin: 0;
                   font-size: 2.3rem;
                   font-weight: 600;
               }
           
               .popover_tip_content {
                   max-height: 45vh;
                   overflow-y: auto;
               }
           
               .popover_text_content {
                   display: block;
                   margin: 1.5rem 0;
           
                   .num_content {
                       display: flex;
           
                       .num {
                           display: flex;
                           width: 2.5rem;
                           margin: 0;
                       }
           
                       .popover_text {
                           text-align: justify;
                           margin: 0;
                       }
           
                   }
                   
                   .bottom_content {
                       font-size: 1.5rem;
                       margin: 0.5rem 0 0 2rem;
                       display: flex;
                       justify-content: space-between;
                       .popover_time {
                           color: #878787;
                           cursor: pointer;
                       }
                       
                       .popover_type {
                           color: #ccc;
                           cursor: pointer;

                           &.blue {
                               color: #2b6bff;
                           }

                           &.disabled {
                               cursor: default;
                           }
                       }
                   }
               }
           
               .popover_botton_content {
                   padding-top: 2rem;
                   position: absolute;
                   bottom: 2rem;
                   right: 2rem;
               }
           }
           
           // otf-opentype
           // ttf-truetype
           @font-face {
               font-family: 'Custom1';
               src: url('@/assets/fonts/1.ttf') format('truetype');
           }
           
           @font-face {
               font-family: 'Custom2';
               src: url('@/assets/fonts/2.ttf') format('truetype');
           }
           
           @font-face {
               font-family: 'Custom3';
               src: url('@/assets/fonts/3.ttf') format('truetype');
           }
           
           @font-face {
               font-family: 'Custom4';
               src: url('@/assets/fonts/4.ttf') format('truetype');
           }
           
           @font-face {
               font-family: 'Custom5';
               src: url('@/assets/fonts/5.ttf') format('truetype');
           }
           
           @font-face {
               font-family: 'Custom6';
               src: url('@/assets/fonts/6.ttf') format('truetype');
           }
           
           @font-face {
               font-family: 'Custom7';
               src: url('@/assets/fonts/7.ttf') format('truetype');
           }
           
           @font-face {
               font-family: 'Custom8';
               src: url('@/assets/fonts/8.otf') format('opentype');
           }
           
           ::v-deep {
               .el-breadcrumb {
                   font-size: 1.4rem;
               }
           }
           
           .scroll {
               border: 1px solid red;
               width: 50rem;
               overflow: hidden;
           }
           
           .navbar {
               z-index: 99999;
               position: fixed;
               z-index: 9;
               width: -webkit-fill-available;
               display: flex;
               align-items: center;
               justify-content: space-between;
               height: 8rem;
               background: #ffffff;
               box-shadow: inset 0rem -0.1rem 0rem 0rem #f0f0f0;
               box-sizing: border-box;
               padding: 0 2rem 0 2rem;
           
               .left {
                   .icon {
                       width: 3rem;
                       height: 3rem;
                       line-height: 5.4rem;
                       text-align: center;
                       cursor: pointer;
           
                       img {
                           width: 2rem;
                           height: 2rem;
                       }
                   }
           
                   .tips {
                       font-weight: 400;
                       font-size: 1.4rem;
                       color: #333333;
                       margin-left: 5rem;
                   }
               }
           
               .right {
                   width: 100%;
                   display: flex;
                   justify-content: space-between;
                   align-items: center;
           
                   .btn {
                       cursor: pointer;
                       min-width: 12.5rem;
                       height: 3rem;
                       background: #eff5ff;
                       border-radius: 0.5rem;
                       border: 0.1rem solid #2b6bff;
                       font-weight: 400;
                       font-size: 1.4rem;
                       color: #2b6bff;
           
                       .icon {
                           width: 1.4rem;
                           height: 1.3rem;
                       }
           
                       span {
                           margin: 0 0.5rem 0 1rem;
                           font-weight: 400;
                           font-size: 1.4rem;
                           color: #2b6bff;
                           white-space: nowrap;
                       }
                   }
           
                   .badge {
                       margin: 0 2.5rem 0 1.5rem;
                       cursor: pointer;
                       
                        img{
                            width: 3rem;
                            cursor: pointer;
                        }
                   }
           
                   .user-info {
                       cursor: pointer;
                       margin-right: 2rem;
                       display: flex;
                       align-items: center;
           
                       span {
                           font-weight: 500;
                           font-size: 1.4rem;
                           color: #333333;
                           margin-right: 2rem;
                       }
           
                       .avatar-group {
                           position: relative;
                           outline: none;
                       }
           
                       .avatar-hat {
                           position: absolute;
                           top: -1rem;
                           left: -0.1rem;
                           height: 4rem;
                           width: 4rem;
                       }
           
                       .avatar {
                           width: 4rem;
                           height: 4rem;
                           border-radius: 50%;
                       }
           
                       .avatar:focus-visible {
                           outline: none;
                       }
                   }
           
                   .select {
                       cursor: pointer;
                       margin-right: 1rem;
           
                       ::v-deep {
                           .language-box {
                               position: relative;
                               top: auto;
                               right: auto;
                           }
                       }
           
                       img {
                           width: 3rem;
                           height: 2rem;
                           margin-right: 1rem;
                       }
           
                       .el-dropdown-link {
                           font-weight: 400;
                           font-size: 1.2rem;
                           color: #333333;
                       }
           
                       .el-dropdown-link:focus-visible {
                           outline: none;
                       }
                   }
               }
           }
           
           ::v-deep {
               .el-dropdown-menu__item {
                   font-size: 1.4rem;
               }
           
               .el-dropdown-menu__item:not(.is-disabled):focus,
               .el-dropdown-menu__item:not(.is-disabled):hover {
                   color: #2b6bff;
               }
           
               .is-text {
                   border: 1px solid #ccc !important;
               }
           }
           
           .flex-center {
               display: flex;
               align-items: center;
               justify-content: center;
           }
           
           .small-font {
               font-size: 10px !important;
           }
        }
</style>
